export default {
    restrack_order: "Track Your Order",
    restrack_placed: "Order Placed",
    restrack_confirmed: "Order Confirmed",
    restrack_delivery: "Out For Delivery",
    restrack_delivered: "Delivered",

    resdelivery_partner: "Delivery Partner",
    resnot_assigned: "Not Assigned",
    reseta: "ETA",

    resorder_progress: "Order Progress",

    ressupport: "Support",
    rescall_driver: "Call Driver",
    reswhatsapp_driver: "WhatsApp Driver",
    resdriver_not_assigned: "Driver not assigned yet",

    resnavigate: "Navigate",
    reslive_location: "Live Location",
    reswaiting_driver_location: "Waiting for driver location...",
    reslast_updated: "Last updated",
}